import Vue from 'vue'
import VueRouter from 'vue-router'
import util from '../assets/js/util'

import error from '../views/error/index'
import main from '@/components/main.vue'

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	base: '/pckm/',
	routes: [{
			path: '/',
			name: 'main',
			component: main,
			meta: {
				title: '防疫服务平台'
			}
		},
		{
			path: '/index.html',
			name: 'main',
			component: main,
			meta: {
				title: '防疫服务平台'
			}
		},
		{
			path: '/protection',
			name: 'protection',
			component: () => import('@/components/protection/index.vue'),
			meta: {
				title: '个人防护知识'
			}
		},
		{
			path: '/protectionDetails',
			name: 'protectionDetails',
			component: () => import('@/components/protection/protectionDetails.vue'),
			meta: {
				title: '个人防护知识'
			}
		},
		{
			path: '/workarea',
			name: 'workarea',
			component: () => import('@/components/workarea/index.vue'),
			meta: {
				title: '工作区域防护知识'
			}
		},
		{
			path: '/workDetails',
			name: 'workDetails',
			component: () => import('@/components/workarea/workDetails.vue'),
			meta: {
				title: '工作区域防护知识'
			}
		},
		{
			path: '/homeProtection',
			name: 'homeProtection',
			component: () => import('@/components/homeProtection/index.vue'),
			meta: {
				title: '居家防护知识'
			}
		},
		{
			path: '/homeDetails',
			name: 'homeDetails',
			component: () => import('@/components/homeProtection/homeDetails.vue'),
			meta: {
				title: '居家防护知识'
			}
		},
		{
			path: '/hospitalization',
			name: 'hospitalization',
			component: () => import('@/components/hospitalization/index.vue'),
			meta: {
				title: '就医流程'
			}
		},
		{
			path: '/hosDetails',
			name: 'hosDetails',
			component: () => import('@/components/hospitalization/hosDetails.vue'),
			meta: {
				title: '就医流程'
			}
		},
		{
			path: '/Viruses',
			name: 'Viruses',
			component: () => import('@/components/Viruses/index.vue'),
			meta: {
				title: '新型冠状病毒肺炎知识'
			}
		},
		{
			path: '/viDetails',
			name: 'viDetails',
			component: () => import('@/components/Viruses/viDetails.vue'),
			meta: {
				title: '新型冠状病毒肺炎知识'
			}
		},
		{
			path: '/maskDetail',
			name: 'maskDetail',
			component: () => import('@/components/maskDetail/index.vue'),
			meta: {
				title: '口罩鉴别'
			}
		},
		{
			path: '/quarters',
			name: 'quarters',
			component: () => import('@/components/quarters/newindex.vue'),
			meta: {
				title: '确诊病例小区'
			}
		},
		{
			path: '/dituList',
			name: 'dituList',
			component: () => import('@/components/quarters/dituList.vue'),
			meta: {
				title: '确诊病例小区'
			}
		},
		{
			path: '/queryBus',
			name: 'queryBus',
			component: () => import('@/components/queryBus/index.vue'),
			meta: {
				title: '停运公交查询'
			}
		},
		{
			path: '/fillIn',
			name: 'fillIn',
			component: () => import('@/components/fillIn/index.vue'),
			meta: {
				title: '人员防疫报备登记'
			}
		},
		{
			path: '/rumorRefuting',
			name: 'rumorRefuting',
			component: () => import('@/components/rumorRefuting/runmorList.vue'),
			meta: {
				title: '谣言你别跑'
			}
		},
		{
			path: '/runmorDetail',
			name: 'runmorDetail',
			component: () => import('@/components/rumorRefuting/runmorDetail.vue'),
			meta: {
				title: '谣言你别跑'
			}
		},
		{
			path: '/Safety',
			name: 'Safety',
			component: () => import('@/components/Safety/index.vue'),
			meta: {
				title: '平安在家学'
			}
		},
		{
			path: '/rent',
			name: 'rent',
			component: () => import('@/components/rent/index.vue'),
			meta: {
				title: '租金优惠一键查'
			}
		},
		{
			path: '/rentdouliu',
			name: 'rentdouliu',
			component: () => import('@/components/rent/rentdouliu.vue'),
			meta: {
				title: '租金优惠一键查'
			}
		},
		{
			path: '/rentAdministration',
			name: 'rentAdministration',
			component: () => import('@/components/rent/rentAdministration.vue'),
			meta: {
				title: '租金优惠一键查'
			}
		},
		{
			path: '/rentQuarters',
			name: 'rentQuarters',
			component: () => import('@/components/rent/rentQuarters.vue'),
			meta: {
				title: '租金优惠一键查'
			}
		},
		{
			path: '/doctorPeople',
			name: 'doctorPeople',
			component: () => import('@/components/doctorPeople/index.vue'),
			meta: {
				title: '韩博士人文讲堂'
			}
		},
		{
			path: '/scenicSpot',
			name: 'scenicSpot',
			component: () => import('@/components/scenicSpot/index.vue'),
			meta: {
				title: '全国景区指南'
			}
		},
		{
			path: '/scenicDetails',
			name: 'scenicDetails',
			component: () => import('@/components/scenicSpot/scenicDetails.vue'),
			meta: {
				title: '全国景区指南'
			}
		},
    {
    	path: '/resumptionIndex',
    	name: 'resumptionIndex',
    	component: () => import('@/components/resumptionWork/index.vue'),
    	meta: {
    		title: '社区防控'
    	}
    },
		{
			path: '/resWork',
			name: 'resWork',
			component: () => import('@/components/resumptionWork/resWork.vue'),
			meta: {
				title: '社区防控'
			}
		}
	]
})
router.historyList = [];
router.isDinwei = false;
router.beforeEach((to, form, next) => {
	// to: Route: 即将要进入的目标 路由对象 ,
	//from: Route: 当前导航正要离开的路由 
	
	try {
		if (to.path) {
			// 关闭自动PV跟踪
			_hmt.push(['_setAutoPageview', false]);
			// 配置多个域名
			const SITEID_ARR = _hmt.cmd || {};
			Object.keys(SITEID_ARR).forEach(id => {
				// 指定对应域名id
				_hmt.push(['_setAccount', id]);
				// PV统计
				_hmt.push(['_trackPageview', `/pckm` + to.fullPath]);
				// console.log('_hmt', _hmt)
			});
		}
	} catch (error) {
		console.log('埋点调用失败', error);
	}	
		
		 
	
	
	if (!util.hasNative() && util.isEquipment().isWeixin) { //不在app里并且在微信里面才去执行
		let option = {};
		if (to.path == '/dituList' || to.path == '/quarters') {
			option = {};
			option.title = '速查2.0｜看看你的小区有没有确诊患者';
			option.desc = '最全！一秒精准定位离你最近的确诊患者在深逗留场所';
		} else if (to.path == '/queryBus') {
			option = {};
			option.title = '速查平台|深圳哪些公交暂停运营';
			option.desc = '2月10日最新数据，平台数据实时更新，数据来源公交运营公司公开信息。';
		} else if (to.path == '/scenicSpot' || to.path == '/scenicDetails') {
			option = {};
			option.title = '致敬白衣天使，免费景区地图';
			option.desc = '全国超1000家景区对医护人员免费开放。你们辛苦了';
		} else if (to.path == '/rent' || to.path == '/rentdouliu' || to.path == '/rentAdministration' || to.path ==
			'/rentQuarters') {
			option = {};
			option.title = '深圳租金优惠一键查询';
			option.desc = '战疫情，保生产，助企业渡难关，深圳在行动！';
		} else if (to.path == '/Safety') {
			option = {};
			option.title = '每月400堂免费直播课，实现能力升级';
			option.desc = '深圳商报&读创联合平安VIPJr免费支持全国孩子，语数英全天直播开课';
		} else if (to.path == '/fillIn') {
			option = {};
			option.title = '入深申报|返深车辆注意，人车提前申报方可通行';
			option.desc = '深圳市公安局与读创为入深车辆、人员提供一站式申报通道，2月8日零时起，深圳实施入深车辆申报措施';
		} else if (to.path == '/doctorPeople') {
			option = {};
			option.title = '停课不停学，博士亲授小学语文网课来了！深耕教材，过目难忘';
			option.desc = '深圳商报&读创联合语文名家韩望喜博士，结合教材，阐发中华文化之美！';
		} else if (to.path == '/rumorRefuting') {
			option = {};
			option.title = '我们一起粉碎谣言，守护真相';
			option.desc = '深圳商报&读创新冠肺炎科普与服务平台助您科学战疫';
		} else if (to.path == '/resumptionIndex' || to.path == '/resWork') {
			option = {};
			option.title = '最新|深圳社区防控优强版';
			option.desc = '快来领取您的深圳复工企业“最贴心攻略”';
		} else {
			option = {};
			option.title = '新型冠状病毒感染的肺炎科普与服务平台';
			option.desc = '科学疫情防范，你该知道的都在这里！';
		}

		util.getLoader(to.fullPath, option);
	}

	util.setTitle(to.meta.title); //设置页面的title
	next()
})

router.afterEach((to, from) => {
	if ((from.name == 'protection' || from.name == 'homeProtection' || from.name == 'workarea' || from.name ==
			'maskDetail') && (to.name == 'main')) {
		router.isDinwei = true
	} else {
		router.isDinwei = false
	}
	router.historyList.push(to.path);

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js